import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { MenuProps } from './MenuProps';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, FormControl, InputLabel, Select, Stack, TextField } from '@mui/material';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import './button.css';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const optionsDefault = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      display: false,
    },
    title: {
      display: true,
      text: 'Tickets',
      position: 'left',
    },
    datalabels: {
      display: true,
      anchor: 'start',
      offset: -31,
      align: "start",
      color: "#224abe",
      textStrokeColor: "#000",
      textStrokeWidth: 1,
      font: {
        size: 16,
        weight: "bold"

      },
    }
  },  
};

export const ChartsDate = ({initialDate, finalDate}) => {

  //const [initialDate, setInitialDate] = useState(new Date());
  //const [finalDate, setFinalDate] = useState(new Date());
  const [ticketsData, setTicketsData] = useState({
    data: [],
    count: 0,
  });

  useEffect(() => {
    handleGetTicketsInformation();
  }, [initialDate, finalDate]);

  const maxValue = Math.max(...ticketsData?.data?.map((item) => item.total));
  const suggestedMax = maxValue + (maxValue * 0.1); 

  const options = {
    ...optionsDefault,
    scales: {                  
      y: {        
        suggestedMax: suggestedMax,        
      }
    }
  };

  const dataCharts = {

    labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => (item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data)),
    datasets: [
      {
        label: 'Tickets',
        data: ticketsData?.data?.length > 0 && ticketsData?.data.map((item) => item.total),
        borderColor: '#7e9df7',
        backgroundColor: 'rgba(21, 29, 133, 0.2)',
        tension: 0,
        fill: true,
        pointRadius: 3,
        pointBackgroundColor: '#fff',
        pointBorderColor: '#224abe',
        pointHoverRadius: 8,
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#224abe',
      },

    ],
  };

  const handleGetTicketsInformation =  async () => {
    try {

      const { data } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}`);
      setTicketsData(data);
    } catch (error) {
      toast.error('Erro ao buscar informações dos tickets');
    }
  }

  return (
    <>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        Total de atendimentos por período
      </Typography>
      {/*}
      <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ my: 2, }} >

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
          <DatePicker
            value={initialDate}
            onChange={(newValue) => { setInitialDate(newValue) }}
            label="Data inicial"
            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}

          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
          <DatePicker
            value={finalDate}
            onChange={(newValue) => { setFinalDate(newValue) }}
            label="Data final"
            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}
          />
        </LocalizationProvider>

        <Button className="buttonHover" onClick={handleGetTicketsInformation} variant='contained' >Filtrar</Button>

      </Stack>
      */}
      <Line options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px', }} />
    </>
  );
}